// Independent uncertain masks must not accumulate into an opaque halo.
// Never discard foreground merely because its colour is white.
export function mergePortraitAlpha(base, person) {
  for (let i = 3; i < base.length; i += 4) base[i] = Math.max(base[i], person[i]);
  return base;
}

function luminance(r, g, b) { return r * 0.299 + g * 0.587 + b * 0.114; }

// Remove only a flat, low-alpha rim that has the same colour as the source
// border. Textured white clothing remains because its local contrast is higher.
export function removeFlatFringe(rgba, alpha, width, height) {
  if (!rgba || !alpha || width < 3 || height < 3) return alpha;
  let red = 0, green = 0, blue = 0, count = 0;
  const sample = (x, y) => {
    const offset = (y * width + x) * 4;
    red += rgba[offset]; green += rgba[offset + 1]; blue += rgba[offset + 2]; count += 1;
  };
  for (let x = 0; x < width; x += Math.max(1, Math.floor(width / 80))) { sample(x, 0); sample(x, height - 1); }
  for (let y = 1; y < height - 1; y += Math.max(1, Math.floor(height / 80))) { sample(0, y); sample(width - 1, y); }
  red /= count; green /= count; blue /= count;
  for (let y = 1; y < height - 1; y += 1) for (let x = 1; x < width - 1; x += 1) {
    const index = y * width + x, offset = index * 4;
    const value = alpha[index];
    if (value < 24 || value > 210) continue;
    const colourDistance = Math.hypot(rgba[offset] - red, rgba[offset + 1] - green, rgba[offset + 2] - blue);
    if (colourDistance > 42) continue;
    const centre = luminance(rgba[offset], rgba[offset + 1], rgba[offset + 2]);
    const neighbours = [index - 1, index + 1, index - width, index + width];
    let variation = 0;
    for (const neighbour of neighbours) {
      const neighbourOffset = neighbour * 4;
      variation += Math.abs(centre - luminance(rgba[neighbourOffset], rgba[neighbourOffset + 1], rgba[neighbourOffset + 2]));
    }
    if (variation / neighbours.length < 9) alpha[index] = 0;
  }
  return alpha;
}
